import React, { Component } from "react";
import { connect } from "react-redux";
import * as ActionTypes from "./../constants/actionTypes.js";
import { defaultAction } from "./../actions/defaultAction.js";
import { initForgotPassword } from "./../thunks/customerInfo.js";
import { PrimaryButton, SecondaryButton } from "../modules/Button";
import styled from "@emotion/styled/macro";

const Input = styled.input`
  border: 1px solid lightgrey !important;
  border-radius: 2px;
  font-style: normal;
  font-size: 14px;
  color: black;
  height: 56px;
  width: 100%;
  margin-bottom: 10px;
  padding-left: 10px;
  &:focus {
    outline-color: #c7a878;
  }
`;

class PasswordAssistance extends Component {
  componentDidMount() {
    // eslint-disable-next-line no-undef
    grecaptcha.render(document.getElementById("recaptchaTargetPassReset"), {
      sitekey: "6LdD7SgTAAAAALjVAm80uYL-CKmPlF1Wwt0CYjv4",
      callback: this.props.setRecaptcha,
      "expired-callback": this.props.setRecaptcha,
    });
  }

  sendPassReqToServer = (e) => {
    e.preventDefault();
    const { userInfo, customerInfo, showOrderErr, resetPassword } = this.props;
    let pathArray = window.location.href.split("/");
    let protocol = pathArray[0];
    let host = pathArray[2];
    let url = protocol + "//" + host + "/forgot-password/";

    if (
      userInfo.get("resetPasswordEmailAddress") &&
      customerInfo.get("recaptchaCode")
    ) {
      resetPassword(
        userInfo.get("resetPasswordEmailAddress"),
        customerInfo.get("recaptchaCode"),
        url
      );
    } else {
      showOrderErr();
    }
  };

  fadeError = () => {
    const { fadeErrorMsg, hideErrorMsg } = this.props;
    window.setTimeout(() => {
      fadeErrorMsg();
    }, 5000);

    window.setTimeout(() => {
      hideErrorMsg();
    }, 5000);
  };

  render() {
    const { userActions, popups, setEmail } = this.props;

    if (userActions.get("showInitForgotPassError") === "SHOW ERROR") {
      this.fadeError();
    }

    return (
      <div
        className="pass-assist-bg"
        style={{
          flex: "1",
          flexBasis: "100%",
          alignItems: "center",
          display: "flex",
        }}
      >
        <div className="signin animated fadeIn">
          <div className="box-outer">
            <form onSubmit={this.sendPassReqToServer} className="box-inner">
              <h1>
                {popups.get("showAccountLockedBox")
                  ? "Account Locked"
                  : "Let’s find your account"}
              </h1>
              <p style={{ color: "black" }}>
                Enter the email address associated with your CardCash account.
                Please Note: For your protection all saved credit card and bank
                information on your account will be erased if you reset your
                password
              </p>
              <Input
                type="email"
                placeholder="Email"
                name="email"
                onChange={setEmail}
                required
              />
              <div id="recaptchaTargetPassReset" className="mar-b-10 mar-t-10">
                {" "}
              </div>
              <PrimaryButton
                disabled={this.props.customerInfo.get("recaptchaCode") == null}
                type="submit"
              >
                Reset Password
              </PrimaryButton>
              <div
                className={
                  userActions.get("showInitForgotPassError") === "SHOW ERROR"
                    ? "mar-t-10 alert alert-danger"
                    : userActions.get("showInitForgotPassError") === "FADE"
                    ? "mar-t-10 alert alert-danger animated fadeOut"
                    : "hide"
                }
              >
                <strong>Invalid Request.</strong> Please check your email and
                make sure you followed Google Recaptcha instructions.
              </div>
              {popups.get("showAccountLockedBox") ? null : (
                <div>
                  <div className="newtoCC">
                    <h5>Remember your password?</h5>
                  </div>
                  <div>
                    <SecondaryButton
                      onClick={() => this.props.history.push("/")}
                    >
                      Sign In
                    </SecondaryButton>
                  </div>
                </div>
              )}
            </form>
          </div>
        </div>
      </div>
    );
  }
}

export default connect(
  (state) => ({
    userInfo: state.userInfo,
    customerInfo: state.customerInfo,
    userActions: state.userActions,
    popups: state.popups,
  }),
  (dispatch) => ({
    setEmail: (e) =>
      dispatch(
        defaultAction(ActionTypes.SET_RESET_PASSWORD_EMAIL, e.target.value)
      ),
    setRecaptcha: (data) =>
      dispatch(defaultAction(ActionTypes.SET_RECAPTCHA, data)),
    resetPassword: (email, recaptchaCode, baseURI) =>
      dispatch(initForgotPassword(email, recaptchaCode, baseURI)),
    fadeErrorMsg: () =>
      dispatch(defaultAction(ActionTypes.FADE_ERROR_INIT_FORGOT_PASSWORD)),
    hideErrorMsg: () =>
      dispatch(defaultAction(ActionTypes.HIDE_ERROR_INIT_FORGOT_PASSWORD)),
    showOrderErr: () =>
      dispatch(defaultAction(ActionTypes.SHOW_ERROR_INIT_FORGOT_PASSWORD)),
  })
)(PasswordAssistance);
